import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { articles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'itaobuy-spreadsheet-sicurezza': 'https://readdy.ai/api/search-image?query=Modern%20cybersecurity%20shield%20concept%20with%20digital%20locks%20and%20encrypted%20data%20streams%20on%20a%20clean%20light%20background%2C%20soft%20grey%20tones%2C%20minimalist%20tech%20aesthetic%2C%20professional%20corporate%20style%2C%20abstract%20security%20visualization%2C%20high%20detail%2C%20sleek%20composition&width=1200&height=500&seq=article-sicurezza&orientation=landscape',
  'itaobuy-spreadsheet-recensione': 'https://readdy.ai/api/search-image?query=Professional%20product%20review%20setup%20with%20a%20laptop%20showing%20spreadsheet%20interface%20next%20to%20a%20notebook%20and%20coffee%20on%20a%20light%20wooden%20desk%2C%20editorial%20review%20style%2C%20warm%20morning%20sunlight%2C%20clean%20modern%20workspace%2C%20lifestyle%20photography%2C%20high%20detail&width=1200&height=500&seq=article-recensione&orientation=landscape',
  'itaobuy-spreadsheet-tutorial': 'https://readdy.ai/api/search-image?query=Step%20by%20step%20tutorial%20guide%20concept%20with%20a%20modern%20laptop%20on%20a%20clean%20desk%20showing%20spreadsheet%20software%2C%20colorful%20sticky%20notes%20and%20stationery%2C%20bright%20natural%20lighting%2C%20educational%20and%20inviting%20atmosphere%2C%20clean%20composition%2C%20high%20detail&width=1200&height=500&seq=article-tutorial&orientation=landscape',
  'itaobuy-spreadsheet-confronto': 'https://readdy.ai/api/search-image?query=Three%20laptops%20side%20by%20side%20each%20displaying%20different%20spreadsheet%20software%20interfaces%20on%20a%20modern%20minimalist%20desk%20setup%2C%20professional%20comparison%20review%20concept%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20tech%20comparison%20aesthetic%2C%20high%20detail&width=1200&height=500&seq=article-confronto&orientation=landscape',
  'itaobuy-spreadsheet-vantaggi': 'https://readdy.ai/api/search-image?query=Ten%20glowing%20advantage%20badge%20icons%20arranged%20neatly%20on%20a%20light%20surface%20with%20a%20central%20tablet%20showing%20spreadsheet%20data%2C%20soft%20ambient%20lighting%2C%20clean%20modern%20aesthetic%2C%20warm%20neutral%20tones%2C%20professional%20style%2C%20high%20detail&width=1200&height=500&seq=article-vantaggi&orientation=landscape',
  'itaobuy-spreadsheet-come-funziona': 'https://readdy.ai/api/search-image?query=Cutaway%20view%20of%20a%20digital%20spreadsheet%20system%20showing%20interconnected%20data%20flows%20and%20automation%20gears%20on%20a%20clean%20white%20background%2C%20modern%20infographic%20style%2C%20soft%20warm%20lighting%2C%20conceptual%20technology%20illustration%2C%20high%20detail&width=1200&height=500&seq=article-funziona&orientation=landscape',
  'itaobuy-spreadsheet-opinioni': 'https://readdy.ai/api/search-image?query=Diverse%20people%20working%20happily%20with%20laptops%20in%20a%20bright%20modern%20coworking%20space%2C%20testimonial%20and%20review%20concept%2C%20warm%20natural%20lighting%2C%20authentic%20candid%20photography%20style%2C%20relaxed%20professional%20atmosphere%2C%20high%20detail&width=1200&height=500&seq=article-opinioni&orientation=landscape',
  'itaobuy-spreadsheet-prezzo': 'https://readdy.ai/api/search-image?query=Clean%20pricing%20comparison%20concept%20with%20three%20tiered%20cards%20on%20a%20light%20surface%20showing%20value%20propositions%2C%20next%20to%20a%20laptop%20with%20spreadsheet%2C%20soft%20warm%20lighting%2C%20modern%20SaaS%20aesthetic%2C%20professional%20editorial%20photography%20style%2C%20high%20detail&width=1200&height=500&seq=article-prezzo&orientation=landscape',
  'itaobuy-spreadsheet-guida-principianti': 'https://readdy.ai/api/search-image?query=Friendly%20beginner%20guide%20concept%20with%20open%20laptop%20showing%20simple%20spreadsheet%20interface%2C%20colorful%20learning%20materials%20sticky%20notes%20on%20warm%20wooden%20desk%2C%20inviting%20atmosphere%2C%20soft%20natural%20light%2C%20educational%20lifestyle%2C%20high%20detail&width=1200&height=500&seq=article-principianti&orientation=landscape',
};

export default function ArticleDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.slug === slug);
  const articleImage = slug ? articleImages[slug] : undefined;
  const articleUrl = `${import.meta.env.VITE_SITE_URL || 'https://itaobuyspread.fun'}/articolo/${slug}`;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen pt-24 px-4 bg-background-50 flex items-center justify-center">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary-50 text-primary-500 flex items-center justify-center">
              <i className="ri-article-line text-2xl"></i>
            </div>
            <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-3">Articolo non trovato</h1>
            <p className="text-foreground-600 mb-6">L'articolo che stai cercando non &egrave; disponibile.</p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all cursor-pointer"
            >
              <i className="ri-home-4-line"></i>
              Torna alla Home
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': articleUrl,
    },
    headline: article.title,
    description: article.description,
    image: articleImage,
    datePublished: '2026-07-14',
    dateModified: '2026-07-14',
    author: { '@type': 'Organization', name: 'itaobuyspread.fun' },
    publisher: { '@type': 'Organization', name: 'itaobuyspread.fun' },
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }} />
      <Navbar />
      <main>
        <article className="w-full pt-24 md:pt-28 pb-16 md:pb-24 px-4 md:px-6 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <div className="mb-8">
              <Link
                to="/"
                className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 transition-colors mb-6 cursor-pointer"
              >
                <i className="ri-arrow-left-line"></i>
                Torna alla Home
              </Link>
              <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4 leading-tight">
                {article.title}
              </h1>
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-6">
                {article.description}
              </p>
              <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line"></i>
                  Aggiornato: 14 Luglio 2026
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  Tempo di lettura: {article.readingTime}
                </span>
              </div>
            </div>

            {articleImage && (
              <div
                className="w-full h-48 md:h-64 rounded-2xl mb-10 bg-cover bg-center"
                style={{
                  backgroundImage: `url('${articleImage}')`
                }}
              ></div>
            )}

            <div className="prose-custom space-y-8">
              {article.sections.map((section, sIdx) => (
                <section key={sIdx} className="bg-background-50 border border-background-200 rounded-2xl p-6 md:p-8">
                  <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-4">
                    {section.title}
                  </h2>

                  {section.type === 'text' && section.content.map((p, pIdx) => (
                    <p key={pIdx} className={`text-sm md:text-base text-foreground-700 leading-relaxed ${pIdx < section.content.length - 1 ? 'mb-3' : ''}`}>
                      {p}
                    </p>
                  ))}

                  {section.type === 'cards' && section.cards && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {section.cards.map((card, cIdx) => (
                        <div key={cIdx} className="flex gap-3 p-4 bg-background-100/50 rounded-xl">
                          <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500">
                            <i className="ri-check-line"></i>
                          </div>
                          <div>
                            <h3 className="text-sm font-semibold text-foreground-900 mb-1">{card.title}</h3>
                            <p className="text-xs text-foreground-600 leading-relaxed">{card.desc}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {section.type === 'tips' && section.tips && (
                    <div className="space-y-3">
                      {section.tips.map((tip, tIdx) => (
                        <div key={tIdx} className="flex gap-3 p-3 bg-background-100 rounded-xl">
                          <div className="w-7 h-7 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 text-xs font-bold">
                            {tIdx + 1}
                          </div>
                          <p className="text-sm text-foreground-700 leading-relaxed">{tip}</p>
                        </div>
                      ))}
                    </div>
                  )}

                  {section.type === 'timeline' && section.timeline && (
                    <div className="space-y-4">
                      {section.timeline.map((step) => (
                        <div key={step.step} className="flex gap-4 p-4 bg-background-100 rounded-xl">
                          <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-sm font-bold">
                            {step.step}
                          </div>
                          <div>
                            <h3 className="text-sm font-semibold text-foreground-900 mb-1">{step.title}</h3>
                            <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {section.type === 'comparison' && section.comparison && (
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm">
                        <thead>
                          <tr className="border-b border-background-200">
                            <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-900">Caratteristica</th>
                            <th className="text-center px-4 py-3 text-xs font-semibold text-primary-700">Itaobuy Spreadsheet</th>
                            <th className="text-center px-4 py-3 text-xs font-semibold text-foreground-600">Alternative</th>
                          </tr>
                        </thead>
                        <tbody>
                          {section.comparison.map((row, rIdx) => (
                            <tr key={rIdx} className={`border-b border-background-200 ${rIdx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}`}>
                              <td className="px-4 py-3 text-foreground-800 font-medium">{row.feature}</td>
                              <td className="px-4 py-3 text-primary-700 font-semibold text-center">{row.itaobuy}</td>
                              <td className="px-4 py-3 text-foreground-500 text-center">{row.altri}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}

                  {section.type === 'faq' && section.faqs && (
                    <div className="space-y-4">
                      {section.faqs.map((faq, fIdx) => (
                        <div key={fIdx} className="p-4 bg-background-100 rounded-xl">
                          <h3 className="text-sm font-semibold text-foreground-900 mb-2">{faq.q}</h3>
                          <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                        </div>
                      ))}
                    </div>
                  )}
                </section>
              ))}

              <section className="bg-primary-50 rounded-2xl p-6 md:p-10 text-center">
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">
                  Pronto a Provare <strong>Itaobuy Spreadsheet</strong>?
                </h2>
                <p className="text-sm md:text-base text-foreground-600 mb-6 max-w-lg mx-auto leading-relaxed">
                  Ora che conosci tutti i dettagli, visita il sito ufficiale e inizia subito.
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="w-full sm:w-auto px-7 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
                  >
                    Itaobuy Sheet
                  </a>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="w-full sm:w-auto px-7 py-3 text-sm font-semibold bg-accent-500 text-background-50 rounded-full hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
                  >
                    Buy It Now
                  </a>
                </div>
              </section>

              <div className="text-center pt-4">
                <Link
                  to="/"
                  className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-primary-600 hover:text-primary-700 bg-primary-50 hover:bg-primary-100 rounded-full transition-all cursor-pointer"
                >
                  <i className="ri-home-4-line"></i>
                  Torna alla Pagina Principale di Itaobuy Spreadsheet
                </Link>
              </div>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}